import { useContext } from 'react';
import { ApiClientContext } from 'src/contexts/ApiClientContext';

const useApiClient = () => useContext(ApiClientContext);

export default useApiClient;
